<template>
  <NModal @closeModal="$emit('closeModal')" class="video-modal">
    <!-- ИСПРАВЛЕНО: Открываем окно, если есть объект видео, даже без описания -->
    <template v-if="video">

      <AppTitle mode="h2" class="video-modal__title">
        <!-- Если описания нет, выводим стандартный заголовок, чтобы верстка не пугала пустотой -->
        <template v-slot:title>
          {{ video.videoDescription || 'Просмотр видеоматериала' }}
        </template>
      </AppTitle>

      <div class="video-modal__video">
        <!-- Первый плеер (HLS по индексу) -->
        <Vue3VideoPlayer
          v-if="video.sourceHlsIndex"
          :src="getVideoUrl(video.sourceHlsIndex)"
          :cover="video.posterName ? getPosterUrl(video.posterName) : ''"
          :core="videoCore"
          playsinline
        />

        <!-- Второй плеер (HLS по внешней ссылке) -->
        <Vue3VideoPlayer
          v-if="!video.sourceHlsIndex && video.externalLinkUrl"
          :src="getVideoUrl(video.externalLinkUrl)"
          :cover="video.posterName ? getPosterUrl(video.posterName) : ''"
          :core="videoCore"
          :viewCore="viewCore"
          :resolution="'auto'"
          playsinline
        />
      </div>
    </template>
  </NModal>
</template>

<script>
import NModal from "./NModal.vue";
import AppTitle from "@/elements/AppTitle.vue";

import { Vue3VideoPlayer } from "@cloudgeek/vue3-video-player";
import { t } from "@/utils/translate";
import { ref, computed } from "vue";
import HLSCore from "@cloudgeek/playcore-hls";

export default {
  emits: ["closeModal"],
  components: { NModal, Vue3VideoPlayer, AppTitle },
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  setup(props) { // Добавили props сюда, чтобы безопасно работать с методами формирования URL
    const players = ref({});

    // Безопасное вычисление ядра плеера (убирает HLS плагин для iPhone)
    const videoCore = computed(() => {
      if (typeof window !== "undefined") {
        const hasMSE = "MediaSource" in window || "WebKitMediaSource" in window;
        return hasMSE ? HLSCore : null;
      }
      return HLSCore;
    });

// Метод для безопасной сборки URL видео
const getVideoUrl = (path) => {
  if (!path || path === 'undefined' || path === '{path}') return '';
  return 'https://navigator.eurekacenter.ru/video' + path;
};

// Метод для безопасной сборки URL постера
const getPosterUrl = (path) => {
  if (!path || path === 'undefined' || path === '{path}') return '';
  return 'https://navigator.eurekacenter.ru/video' + path;
};

    function viewCore(id, player) {
      players.value[id] = player;
    }

    return { t, videoCore, viewCore, getVideoUrl, getPosterUrl };
  },
};
</script>
<style lang="scss">
.video-modal {
  // --- СТИЛИЗАЦИЯ САМОЙ МОДАЛКИ НА СМАРТФОНАХ ---
  // Находим корневую карточку внутри компонента NModal (обычно это .modal или .n-modal-content)
  :deep(.n-modal-content),
  :deep(.modal-box),
  & {
    width: 95% !important; // Модалка займет 95% ширины экрана смартфона, оставив аккуратные поля
    max-width: 800px !important; // На больших мониторах ПК окно не растянется шире 800px
    margin: 0 auto;
    border-radius: 16px;
    padding: 24px !important;
    box-sizing: border-box;
  }

  &__title {
    margin-bottom: 20px;

    :deep(*) {
      font-size: 18px !important; // Чуть уменьшаем заголовок на мобилках, чтобы он не занимал пол-экрана
      line-height: 1.4 !important;
      font-weight: 700;
      color: #0f172a;
    }
  }

  // --- ГЕОМЕТРИЯ ПЛЕЕРА ---
  &__video {
    width: 100% !important;
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    background-color: #000000; // Черный фон, как в кинотеатрах, скрывает поля видео

    // Магия жесткого удержания пропорций 16:9
    aspect-ratio: 16 / 9 !important;

    // Заставляем внутренний плеер Vue3VideoPlayer занять всё выделенное место
    :deep(.vue3-video-player),
    :deep(video),
    :deep(.vjs-tech) {
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important; // Видео масштабируется без искажений и обрезаний краев
    }
  }

  // --- АДАПТИВНОСТЬ ПОД БОЛЬШИЕ ЭКРАНЫ ПК ---
  @media (min-width: 768px) {
    :deep(.n-modal-content),
    :deep(.modal-box),
    & {
      width: 800px !important; // На компьютерах возвращаем стандартную красивую ширину
      padding: 32px !important;
    }

    &__title {
      :deep(*) {
        font-size: 22px !important; // На мониторах делаем заголовок крупным
      }
    }
  }
}

// =========================================================================
// ИСПРАВЛЕНИЕ ДЛЯ СМАРТФОНОВ: УКРОЩЕНИЕ ФОНОВЫХ НАДПИСЕЙ
// =========================================================================
@media (max-width: 768px) {
  // Полностью выпиливаем фоновые дублирующиеся заголовки,
  // которые улетали на 40% вниз и перекрывали синий контент на iPhone SE/12
  .page-title_bg-item--1,
  .page-title_bg-item--2,
  :deep(.page-title_bg-item--1),
  :deep(.page-title_bg-item--2) {
    display: none !important; // Уничтожает наложение текста под корень
    position: relative !important;
    top: auto !important;
    left: auto !important;
    right: auto !important;
    margin-bottom: 24px !important;
    padding: 0 16px !important;
    font-size: 24px !important;
    line-height: 1.3 !important;
    color: #0f172a !important;
    animation: none !important;
  }
}

// =========================================================================
// ГЛОБАЛЬНЫЙ ВЫЖИГ ФОНОВОГО ТЕКСТА НА МОБИЛКАХ (ВНЕ ДРУГИХ СЕЛЕКТОРОВ)
// =========================================================================
@media (max-width: 768px) {
  // Селектор [class*="..."] находит любой класс, содержащий эту подстроку.
  // Это спасет от опечаток вроде "bg-ites", "item-1--" и прочих.
  [class*="page-title__bg-"],
  [class*="page-title_bg-"],
  [class*="bg-item"],
  [class*="bg-ites"] {
    display: none !important; // Полностью выключаем отображение на смартфонах
  }
}

</style>